import React from 'react';
import { Mail, Phone, MapPin, Calendar, Award, BookOpen } from 'lucide-react';

const StaffPage = () => {
  // Sample staff data - in real app, this would come from database
  const staffMembers = [
    {
      id: 1,
      name: "Sr. Neddie B. Nueva, DC",
      title: "Guidance Coordinator",
      department: "Guidance Services",
      photo: "/images/sorneddie.jpg",
      email: "nuevasr.neddiedc@gmail.com",
      phone: "",
      officeLocation: "Guidance Center",
      officeHours: "Monday-Friday: 8:00 AM - 5:00 PM",
      bio: "Sr. Neddie B. Nueva serves as the Guidance Coordinator, providing leadership and direction to the guidance and counseling programs. With extensive experience in guidance and counseling, she is dedicated to supporting the holistic development of students.",
      specializations: [
        "Guidance Program Coordination",
        "Student Development",
        "Counseling Services"
      ],
      education: [
        "MAEd Guidance and Counseling / Philippine Normal University",
        "BSED – Guidance and Counseling / Santa Isabel College"
      ],
      certifications: []
    },
    {
      id: 2,
      name: "Casimira D. Jarabo, Ph.D.",
      title: "VP for Student Development, Wellness and External Linkages",
      department: "Student Development",
      photo: "/images/casimira.jpg",
      email: "slmcsi.sdwel2025@gmail.com",
      phone: "",
      officeLocation: "Guidance Center",
      officeHours: "Monday-Friday: 8:00 AM - 5:00 PM",
      bio: "Dr. Casimira D. Jarabo leads the Student Development, Wellness and External Linkages division, overseeing comprehensive programs that support student well-being and community partnerships.",
      specializations: [
        "Student Development",
        "Wellness Programs",
        "External Linkages",
        "Strategic Planning"
      ],
      education: [
        "Doctorate Degree / Annunciation College of Bacon Sorsogon Unit, Inc."
      ],
      certifications: []
    },
    {
      id: 3,
      name: "Rena Giba Balbalosa",
      title: "Guidance Associate, BED SHS",
      department: "Senior High School",
      photo: "/images/rena.jpg",
      email: "slmcsrgb@gmail.com",
      phone: "",
      officeLocation: "Guidance Center",
      officeHours: "Monday-Friday: 8:00 AM - 5:00 PM",
      bio: "Rena Giba Balbalosa serves as the Guidance Associate for the Basic Education Department's Senior High School, providing counseling and guidance services to help students navigate their academic and personal development.",
      specializations: [
        "Senior High School Counseling",
        "Academic Guidance",
        "Career Planning"
      ],
      education: [
        "Bachelor of Science in Psychology | Bicol University"
      ],
      certifications: []
    },
    {
      id: 4,
      name: "Ramil C. Esmeria",
      title: "Guidance Associate - BED (K-10)",
      department: "Basic Education",
      photo: "/images/ramil.jpg",
      email: "ramilesmeria66@gmail.com",
      phone: "",
      officeLocation: "Guidance Center",
      officeHours: "Monday-Friday: 8:00 AM - 5:00 PM",
      bio: "Ramil C. Esmeria serves as the Guidance Associate for the Basic Education Department (K-10), providing comprehensive guidance and counseling services to support the development of young learners.",
      specializations: [
        "K-10 Counseling",
        "Child Development",
        "Academic Support"
      ],
      education: [
        "Master of Arts in Counseling",
        "Bachelor of Science in Psychology"
      ],
      certifications: []
    },
    {
      id: 5,
      name: "Antonette Honrubia Bon",
      title: "HED Guidance Associate",
      department: "Higher Education",
      photo: "/images/antonette.jpg",
      email: "bon.slmci@gmail.com",
      phone: "",
      officeLocation: "Guidance Center",
      officeHours: "Monday-Friday: 8:00 AM - 5:00 PM",
      bio: "Antonette Honrubia Bon serves as the Guidance Associate for the Higher Education Department, providing counseling and guidance services to college students as they pursue their academic and career goals.",
      specializations: [
        "College Counseling",
        "Career Guidance",
        "Personal Development"
      ],
      education: [
        "Bachelor of Science in Psychology | Bicol University"
      ],
      certifications: []
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-800 to-blue-900 text-white py-16">
        <div className="container-custom">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold mb-6">SLMCS Guidance Personnel</h1>
            <p className="text-xl text-blue-100">
              Meet our dedicated team of professional counselors and advisors who are 
              committed to supporting your academic and personal success.
            </p>
          </div>
        </div>
      </section>

      {/* Team Introduction */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="section-title">Professional Excellence</h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Our guidance team combines years of professional experience with a genuine passion 
              for student development. Each team member brings unique expertise and a commitment 
              to helping you achieve your goals.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Award className="w-8 h-8 text-blue-800" />
              </div>
              <h3 className="text-lg font-semibold mb-2">Licensed Professionals</h3>
              <p className="text-gray-600 text-sm">
                All our counselors are licensed professionals with advanced degrees and ongoing training.
              </p>
            </div>
            <div>
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <BookOpen className="w-8 h-8 text-blue-800" />
              </div>
              <h3 className="text-lg font-semibold mb-2">Specialized Expertise</h3>
              <p className="text-gray-600 text-sm">
                Each team member specializes in specific areas to provide you with expert guidance.
              </p>
            </div>
            <div>
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Calendar className="w-8 h-8 text-blue-800" />
              </div>
              <h3 className="text-lg font-semibold mb-2">Accessible Support</h3>
              <p className="text-gray-600 text-sm">
                Flexible scheduling and multiple contact methods ensure you can get help when you need it.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Staff Profiles */}
      <section className="py-16">
        <div className="container-custom">
          <div className="space-y-16">
            {staffMembers.map((staff, index) => (
              <div key={staff.id} className={`grid lg:grid-cols-2 gap-12 items-start ${
                index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''
              }`}>
                {/* Photo and Contact Info */}
                <div className={`${index % 2 === 1 ? 'lg:col-start-2' : ''}`}>
                  <div className="card text-center">
                    <div className="w-48 h-48 mx-auto mb-6 rounded-full overflow-hidden bg-gray-200">
                      <img 
                        src={staff.photo} 
                        alt={staff.name}
                        className="w-full h-full object-cover object-top"
                        onError={(e) => {
                          e.target.src = '/images/default-staff.jpg';
                        }}
                      />
                    </div>
                    
                    <h3 className="text-2xl font-bold text-gray-800 mb-2">{staff.name}</h3>
                    <p className="text-blue-800 font-semibold mb-1">{staff.title}</p>
                    <p className="text-gray-600 mb-6">{staff.department}</p>
                    
                    <div className="space-y-3 text-left">
                      <div className="flex items-center">
                        <Mail className="w-4 h-4 text-gray-500 mr-3" />
                        <a href={`mailto:${staff.email}`} className="text-blue-600 hover:text-blue-700 text-sm">
                          {staff.email}
                        </a>
                      </div>
                      <div className="flex items-start">
                        <MapPin className="w-4 h-4 text-gray-500 mr-3 mt-1" />
                        <span className="text-gray-700 text-sm">{staff.officeLocation}</span>
                      </div>
                      <div className="flex items-start">
                        <Calendar className="w-4 h-4 text-gray-500 mr-3 mt-1" />
                        <span className="text-gray-700 text-sm">{staff.officeHours}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Bio and Details */}
                <div className={`${index % 2 === 1 ? 'lg:col-start-1 lg:row-start-1' : ''}`}>
                  <div className="space-y-6">
                    <div>
                      <h4 className="text-lg font-semibold text-gray-800 mb-3">About</h4>
                      <p className="text-gray-600 leading-relaxed">{staff.bio}</p>
                    </div>
                    
                    <div>
                      <h4 className="text-lg font-semibold text-gray-800 mb-3">Specializations</h4>
                      <div className="flex flex-wrap gap-2">
                        {staff.specializations.map((spec, idx) => (
                          <span 
                            key={idx}
                            className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm"
                          >
                            {spec}
                          </span>
                        ))}
                      </div>
                    </div>
                    
                    <div>
                      <h4 className="text-lg font-semibold text-gray-800 mb-3">Education</h4>
                      <ul className="space-y-1">
                        {staff.education.map((edu, idx) => (
                          <li key={idx} className="text-gray-600 text-sm flex items-start">
                            <span className="w-2 h-2 bg-blue-800 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                            {edu}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-blue-800 text-white">
        <div className="container-custom text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Connect?</h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Our team is here to support you. Schedule an appointment with the counselor 
            who best matches your needs, or contact us for guidance on who to see.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="mailto:guidance@school.edu" 
              className="btn-secondary"
            >
              <Mail className="w-5 h-5 mr-2" />
              Email Us
            </a>
            <a 
              href="tel:(555)123-4567" 
              className="btn-outline border-white text-white hover:bg-white hover:text-blue-800"
            >
              <Phone className="w-5 h-5 mr-2" />
              Call Us
            </a>
          </div>
        </div>
      </section>

      {/* Office Information */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="section-title">Visit Our Office</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Our guidance center is conveniently located on campus with comfortable, 
              private spaces for counseling and meetings.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-xl font-semibold mb-4">Location & Hours</h3>
              <div className="space-y-4">
                <div>
                  <h4 className="font-medium text-gray-800">Address</h4>
                  <p className="text-gray-600">
                    Guidance Center Building<br />
                    Main Campus, Ground Floor<br />
                    Your School Name<br />
                    City, State 12345
                  </p>
                </div>
                <div>
                  <h4 className="font-medium text-gray-800">Office Hours</h4>
                  <p className="text-gray-600">
                    Monday - Friday: 8:00 AM - 5:00 PM<br />
                    Saturday: 9:00 AM - 12:00 PM<br />
                    Sunday: Closed
                  </p>
                </div>
                <div>
                  <h4 className="font-medium text-gray-800">Emergency Contact</h4>
                  <p className="text-gray-600">
                    For urgent matters outside office hours,<br />
                    contact Campus Security: (555) 123-9999
                  </p>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-xl font-semibold mb-4">What to Expect</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-blue-800 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span className="text-gray-600">Comfortable, private counseling rooms</span>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-blue-800 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span className="text-gray-600">Confidential and welcoming environment</span>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-blue-800 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span className="text-gray-600">Resource library and study materials</span>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-blue-800 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span className="text-gray-600">Group meeting and workshop spaces</span>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-blue-800 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span className="text-gray-600">Accessible facilities for all students</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StaffPage;